/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TeamLegalEntityBillingProfile } from './';
import {
    TeamLegalEntityBillingProfileFromJSON,
    TeamLegalEntityBillingProfileFromJSONTyped,
    TeamLegalEntityBillingProfileToJSON,
} from './';
import type { TeamLegalEntityLegalInformation } from './';
import {
    TeamLegalEntityLegalInformationFromJSON,
    TeamLegalEntityLegalInformationFromJSONTyped,
    TeamLegalEntityLegalInformationToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamLegalEntitySummary
 */
export interface TeamLegalEntitySummary {
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntitySummary
     */
    legalEntityId: string;
    /**
     * 
     * @type {TeamLegalEntityLegalInformation}
     * @memberof TeamLegalEntitySummary
     */
    legalInformation: TeamLegalEntityLegalInformation;
    /**
     * 
     * @type {Array<TeamLegalEntityBillingProfile>}
     * @memberof TeamLegalEntitySummary
     */
    additionalBillingProfiles: Array<TeamLegalEntityBillingProfile>;
}

/**
 * Check if a given object implements the TeamLegalEntitySummary interface.
 */
export function instanceOfTeamLegalEntitySummary(value: object): value is TeamLegalEntitySummary {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('legalInformation' in value) || value['legalInformation'] === undefined) return false;
    if (!('additionalBillingProfiles' in value) || value['additionalBillingProfiles'] === undefined) return false;
    return true;
}

export function TeamLegalEntitySummaryFromJSON(json: any): TeamLegalEntitySummary {
    return TeamLegalEntitySummaryFromJSONTyped(json, false);
}

export function TeamLegalEntitySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLegalEntitySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'legalInformation': TeamLegalEntityLegalInformationFromJSON(json['legalInformation']),
        'additionalBillingProfiles': ((json['additionalBillingProfiles'] as Array<any>).map(TeamLegalEntityBillingProfileFromJSON)),
    };
}

export function TeamLegalEntitySummaryToJSON(value?: TeamLegalEntitySummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'legalInformation': TeamLegalEntityLegalInformationToJSON(value['legalInformation']),
        'additionalBillingProfiles': ((value['additionalBillingProfiles'] as Array<any>).map((v) => TeamLegalEntityBillingProfileToJSON(v))),
    };
}

